import { RefObject, useEffect } from 'react';

export function useDisableFocusInsideRef(
  ref: RefObject<HTMLElement | null>,
  focusEnabled: boolean,
) {
  useEffect(() => {
    const elements =
      ref.current?.querySelectorAll<HTMLElement>(
        'button, [href], input, select, textarea,[tabindex]:not([tabindex="-1"]), [data-original-tabindex]:not(null)',
      ) ?? [];

    const restoreFocus = (el: HTMLElement) => {
      if (el.hasAttribute('tabindex') && el.getAttribute('tabindex') === '-1') {
        el.removeAttribute('tabindex');
      }
      // Restore previous tabindex if it was stored
      const prevTabindex = el.getAttribute('data-original-tabindex');
      if (prevTabindex !== null) {
        el.setAttribute('tabindex', prevTabindex);
        el.removeAttribute('data-original-tabindex');
      }
    };

    elements.forEach((el) => {
      if (focusEnabled) {
        restoreFocus(el);
      } else {
        // Save current tabindex before disabling
        if (el.hasAttribute('tabindex')) {
          el.setAttribute('data-original-tabindex', el.getAttribute('tabindex') as string);
        }
        el.setAttribute('tabindex', '-1');
      }
    });

    return () => {
      elements.forEach(restoreFocus);
    };
  }, [ref.current, focusEnabled]);
}
